import { PAGE_ROUTES } from "./stateTypes";

export const SITE_URL = "https://ashthedietitian.co.za";
export const DEFAULT_SEO_IMAGE = `${SITE_URL}/images/meta.webp`;

const SEO_DATA = {
  [PAGE_ROUTES.HOME]: {
    title: "Ash The Dietitian",
    description: "Ash The Dietitian is a registered dietitian and nutritionist based in Johannesburg & Cape Town, South Africa. She offers individual consultations, group workshops, and corporate wellness programs.",
    noIndex: false,
  },
  [PAGE_ROUTES.CORPORATE]: {
    title: "Corporate Offering | Ash The Dietitian",
    description: "Creating a balanced lifestyle for your corporate team. Request a quote for health screens, employee consultations, group programs, wellness days, canteen assessments, nutrition talks, weight loss camps, and wellness newsletters.",
    noIndex: false,
  },
  [PAGE_ROUTES.BOOK]: {
    title: "Book a Consultation | Ash The Dietitian",
    description: "Book a consultation with Ash The Dietitian. Start today - both online and in-person consultations available in Johannesburg and Cape Town.",
    noIndex: false,
  },
  [PAGE_ROUTES.STORE]: {
    title: "Store | Ash The Dietitian",
    description: "Shop pre-designed and custom meal and exercise plans, plus health guides for specific conditions, from a registered dietitian.",
    noIndex: false,
  },
  [PAGE_ROUTES.CONTACT]: {
    title: "Contact | Ash The Dietitian",
    description: "Contact Ash The Dietitian for any questions or to arrange a consultation. Our offices are in Johannesburg and Cape Town.",
    noIndex: false,
  },
  [PAGE_ROUTES.MEAL_PLAN_FORM]: {
    title: "Meal Plan Questionnaire | Ash The Dietitian",
    description: "Complete your meal plan questionnaire so Ash The Dietitian can prepare your personalised eating plan.",
    noIndex: true,
  },
  [PAGE_ROUTES.EBOOK]: {
    title: "Free Recipe E-Book | Ash The Dietitian",
    description: "Sign up to Ash The Dietitian's newsletter for a free copy of \"A registered dietitian's top 5 low calorie, high protein recipes\".",
    noIndex: false,
  },
  [PAGE_ROUTES.WELCOME]: {
    title: "Welcome | Ash The Dietitian",
    description: "Start today with a personal assessment built around your body. See what your first consultation with Ash The Dietitian looks like and what happens next.",
    noIndex: false,

  },
  [PAGE_ROUTES.THANK_YOU]: {
    title: "Purchase Successful | Ash The Dietitian",
    description: "Thank you for your purchase from Ash The Dietitian. Check your inbox for your next steps.",
    noIndex: true,
  },
  [PAGE_ROUTES.CANCEL_SUBSCRIPTION]: {
    title: "Cancel Subscription | Ash The Dietitian",
    description: "Cancel your Ash The Dietitian subscription.",
    noIndex: true,
  },
};

export const NOT_FOUND_SEO = {
  title: "Page Not Found | Ash The Dietitian",
  description: "The page you're looking for couldn't be found - Ash The Dietitian has recently rebuilt the site.",
  noIndex: true,
};

export default SEO_DATA;
